import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { RuleDao } from "../../core/model/rule-dto";
import { RuleService } from "../../core/service/rule.service";

@Component({
  selector: "app-add-rule-engine",
  templateUrl: "./add-rule-engine.component.html",
  styleUrls: ["./add-rule-engine.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddRuleEngineComponent implements OnInit {
  editorOptions = { theme: "vs-dark", language: "javascript" };
  code: string  = `
    function x() {
        console.log("Hello world!")
    }
 `;
  rule: RuleDao = new RuleDao();

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _ruleService: RuleService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      ruleNamespace: [null, Validators.compose([Validators.required])],
      condition: [null, Validators.compose([Validators.required])],
      action: [null, Validators.compose([Validators.required])],
      priority: [null, Validators.compose([Validators.required])],
      description: [null, Validators.compose([Validators.required])]
    });
  }

  ngOnInit() {}

  save(): void {
    this.pressButton = true;
    this.rule.ruleId = null;
    this._ruleService
      .add(this.rule)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
